'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = requestMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function captureError(error) {
  return new _promise2.default(function (accept) {
    if (!error.response) return accept({ error: error });

    return error.response.json().then(function (json) {
      return accept({ error: error, result: json });
    }).catch(function () {
      return accept({ error: error });
    });
  });
}

function requestMiddleware() {
  var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState);
        }

        var promise = action.promise,
            type = action.type,
            rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'type']);

        if (!promise) return next(action);

        var REQUEST = type;
        var SUCCESS = type + '_SUCCESS';
        var FAILURE = type + '_FAILURE';

        next((0, _extends3.default)({}, rest, { type: REQUEST }));

        return promise((0, _extends3.default)({}, helpers, { dispatch: dispatch })).then(function (result) {
          return next((0, _extends3.default)({}, rest, { result: result, type: SUCCESS }));
        }, function (error) {
          return captureError(error).then(function (error) {
            return next((0, _extends3.default)({}, rest, error, { type: FAILURE }));
          });
        }).catch(function (error) {
          console.error('MIDDLEWARE ERROR:', error);
          next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        });
      };
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/chemist/dist/store/requestMiddleware.js
// module id = 653
// module chunks = 0